<template>
  <div class="payment" id="payment">
    <div class="g-container container">
      <div class="tip">{{ $t('payment.tip') }}</div>
      <h2 class="g-title left title">{{ $t('payment.title') }}</h2>
      <div class="tip2">{{ $t('payment.tip2') }}</div>
      <div class="info__wrapper">
        <div class="info">
          <div class="g-font-mid info__title top">{{ $t('payment.title1') }}</div>
          <div class="info__content top">{{ $t('payment.title1Content') }}</div>
        </div>
        <div class="info__fake"></div>
        <div class="info">
          <div class="g-font-mid info__title">{{ $t('payment.title2') }}</div>
          <div class="info__content">
            <div>{{ $t('payment.title2Content1') }}</div>
            <div>{{ $t('payment.title2Content2') }}</div>
          </div>
        </div>
        <div class="info">
          <div class="g-font-mid info__title">{{ $t('payment.title3') }}</div>
          <div class="info__content">
            <div>{{ $t('payment.title3Content1') }}</div>
            <div>{{ $t('payment.title3Content2') }}</div>
            <div>{{ $t('payment.title3Content3') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Payment',
};
</script>

<style lang="scss" scoped>
  .payment {
    padding-top: 100px;
    padding-bottom: 118px;
    background-color: rgba(29, 37, 60, 1);
    background-image: url("../../assets/earth.png");
    background-repeat: no-repeat;
    background-size: 693px;
    background-position: right calc(100% - 45px);
    @media (max-width: 960px) {
      background-position: calc(100% + 220px) calc(100% + 80px);
    }
  }

  .container {
    @media (max-width: 960px) {
      max-width: 800px;
    }
  }

  .tip {
    font-size: 16px;
    line-height: 28px;
    color: var(--color-content-light);
  }

  .tip2 {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-content-light);
  }

  .title {
    margin-top: 20px;
    color: var(--color-base-light);
  }

  .info__wrapper {
    margin-top: 60px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 120px;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;

      .info__fake {
        display: none;
      }
    }
  }

  .info {
    max-width: 500px;
  }

  .info__title {
    font-size: 30px;
    line-height: 36px;
    color: var(--color-base-light);
  }

  .info__content {
    margin-top: 40px;
    font-size: 18px;
    line-height: 28px;
    color: var(--color-base-light);
    opacity: .7;

    &.top {
      opacity: .6;
    }
  }
</style>
